import { useState, useEffect } from 'react';

export function useTouchDevice() {
  const [isTouch, setIsTouch] = useState(false);

  useEffect(() => {
    const touchQuery = window.matchMedia('(pointer: coarse)');
    setIsTouch(touchQuery.matches);

    const handler = (e) => setIsTouch(e.matches);
    touchQuery.addEventListener('change', handler);
    return () => touchQuery.removeEventListener('change', handler);
  }, []);

  return isTouch;
}
